var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33331 3.5L2.64238 3.60302C4.18242 4.11637 4.95244 4.37304 5.39288 4.98411C5.83331 5.59519 5.83331 6.40686 5.83331 8.03021V11.0833C5.83331 14.3832 5.83331 16.0331 6.85844 17.0582C7.88357 18.0833 9.53348 18.0833 12.8333 18.0833H22.1666",
    stroke: "#007F6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 21C9.7165 21 10.5 21.7835 10.5 22.75C10.5 23.7165 9.7165 24.5 8.75 24.5C7.7835 24.5 7 23.7165 7 22.75C7 21.7835 7.7835 21 8.75 21Z",
    stroke: "#007F6D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 21.0001C20.2165 21.0001 21 21.7836 21 22.7501C21 23.7166 20.2165 24.5001 19.25 24.5001C18.2835 24.5001 17.5 23.7166 17.5 22.7501C17.5 21.7836 18.2835 21.0001 19.25 21.0001Z",
    stroke: "#007F6D",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83331 7H19.1921C21.5896 7 22.7883 7 23.307 7.78664C23.8257 8.57328 23.3535 9.67509 22.4091 11.8787L21.9091 13.0454C21.4682 14.0742 21.2477 14.5886 20.8094 14.8776C20.3711 15.1667 19.8114 15.1667 18.6921 15.1667H5.83331",
    stroke: "#007F6D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.e60a462f934ef70ede8bf101348234ea.svg";
export { ForwardRef as ReactComponent };